import { api } from '@bilibili-maoer/web-utils'

export module Links {
  export const CONTRACT_SERVICE_AGREEMENT = `${api.MISSEVAN_LINK_PREFIX_URL}/fm/live-guild-agreement`
  /** 公会数据中心导出表格的 API URL */
  export const GUILD_DATA_REPORT_EXPORT_API_URL = '/api/v2/guild/data-report-export'
  /** 直播公会 - 公会收益导出表格的 API URL */
  export const GUILD_GUILD_INCOME_EXPORT_API_URL = '/api/v2/guild/guildincomeexport-v3'
}
